export enum LineBeaconServiceType {
  TENMAX = 'tenmaxSupport',
  SELF_SERVE = 'advertiserSelfServe'
}

export enum LineMessageType {
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  JOIN = 'JOIN',
  COUPON = 'COUPON'
}

// TODO: 如果未來平台語系都定義用 BCP 47 的格式，可以調整 enum 的位置，就不是只單純 for Line Beacon
export enum LineUserLanguage {
  ALL = 'all',
  ZH_HANT = 'zh-Hant',
  ZH_HANS = 'zh-Hans',
  EN = 'en',
  JA = 'ja',
  TH = 'th'
}

export type LineMessage =
  | {
      type: LineMessageType.TEXT;
      message: string;
    }
  | {
      type: LineMessageType.IMAGE;
      imageUrl: string;
    }
  | {
      type: LineMessageType.VIDEO;
      videoUrl: string;
      previewImageUrl: string;
    }
  | {
      type: LineMessageType.JOIN;
      officialAccount: string;
    }
  | {
      type: LineMessageType.COUPON;
      couponId: string;
    };

export type LineMessageFormData =
  | {
      type: LineMessageType.TEXT;
      message: string;
    }
  | {
      type: LineMessageType.IMAGE;
      image: FileFieldData;
    }
  | {
      type: LineMessageType.VIDEO;
      video: FileFieldData;
      previewImage: FileFieldData;
    }
  | {
      type: LineMessageType.JOIN;
      officialAccount: string;
    }
  | {
      type: LineMessageType.COUPON;
      couponId: string;
    };

type TenMaxLineBeaconConfig = {
  lineBeaconServiceType: LineBeaconServiceType.TENMAX;
  lineBeaconHardwareId: string;
  lineBotChannelSecret: string;
  lineBotChannelAccessToken: string;
};

type SelfServeLineBeaconConfig = OverrideAndNeverOthers<
  TenMaxLineBeaconConfig,
  {
    lineBeaconServiceType: LineBeaconServiceType.SELF_SERVE;
    lineBeaconHardwareId: string;
  }
>;

export type LineBeaconConfig =
  | TenMaxLineBeaconConfig
  | SelfServeLineBeaconConfig;
